import React from "react";

const ChevronRightGrey = ({
  width = 7,
  height = 10,
}: {
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 7 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.29551 4.99956L0.583008 1.28706L1.64351 0.226562L6.41651 4.99956L1.64351 9.77256L0.583008 8.71206L4.29551 4.99956Z"
        fill="#868C98"
      />
    </svg>
  );
};

export default ChevronRightGrey;
